
import React, { useEffect, useState } from "react";
import { Menu, Button, MenuProps, Input, Modal, Tabs, Select, message, notification, Row, Col, Form } from 'antd';
import sources from "../../common/sources";
import { CloseOutlined } from '@ant-design/icons';
const { TextArea } = Input;

const CreateConversion = ({ displayCreateConversion, setDisplayCreateConversion, price, onCreateConversion, currentConversion = null }) => {
    const [conversion, setConversion] = useState(currentConversion);

    function calculateConversion(fn, price) {
        return new Function(`const x = ${price}; return ${fn}`)();
    }

    const onClickOk = () => {
        try {

            calculateConversion(conversion, 10)
        } catch (err) {
            console.log({ err })
            message.error('Conversion formula is not in correct format');
            return;
        }
        setDisplayCreateConversion(false);
        onCreateConversion(conversion);
    }
    const goBack = () => {
        setDisplayCreateConversion(false);
    }


    return (
        <Modal
            maskClosable={false}
            closeIcon={<CloseOutlined style={{ color: "white" }} />}
            bodyStyle={{
                backgroundColor: 'black',
                border: "1px solid grey"
            }}
            visible={displayCreateConversion} footer={null} onCancel={() => { setDisplayCreateConversion(false); }}>

            <>
                <div style={{ fontWeight: "600", color: "white" }}>
                    <svg style={{ position: "relative", top: 4, marginRight: 5 }} xmlns="http://www.w3.org/2000/svg" width="20.68" height="23" viewBox="0 0 26.68 28">
                        <path id="Path_6005" data-name="Path 6005" d="M220.673,138.6a5.026,5.026,0,0,0-5.019,5.02.785.785,0,1,0,1.571,0,3.453,3.453,0,0,1,3.448-3.449.785.785,0,0,0,0-1.571Zm0-3.074a8.1,8.1,0,0,0-8.093,8.094,9.692,9.692,0,0,0,1.789,5.141,7.151,7.151,0,0,1,1.389,3.651v3.282a2.586,2.586,0,0,0,2.585,2.587H223a2.589,2.589,0,0,0,2.587-2.586v-3.282a7.155,7.155,0,0,1,1.389-3.652,9.684,9.684,0,0,0,1.789-5.141,8.1,8.1,0,0,0-8.093-8.094ZM223,156.706h-4.659a1.01,1.01,0,0,1-1.011-.971h6.683a1.016,1.016,0,0,1-1.012.971Zm1.016-2.542h-6.691v-.971h6.691v.97Zm1.611-6.212a9.863,9.863,0,0,0-1.556,3.671h-6.8a9.852,9.852,0,0,0-1.556-3.671,8.2,8.2,0,0,1-1.566-4.335,6.523,6.523,0,1,1,13.046,0,8.2,8.2,0,0,1-1.566,4.336Zm7.6-5.122h-2.289a.785.785,0,0,0,0,1.571h2.289a.785.785,0,0,0,0-1.571Zm-22.036.786a.785.785,0,0,0-.785-.785h-2.289a.785.785,0,0,0,0,1.571h2.289A.785.785,0,0,0,211.193,143.616Zm9.48-9.48a.785.785,0,0,0,.785-.785v-2.289a.785.785,0,0,0-1.571,0v2.289A.785.785,0,0,0,220.673,134.136Zm8.891,5.133a.784.784,0,0,0,.392-.105l1.982-1.145a.785.785,0,1,0-.785-1.36l-1.982,1.144a.786.786,0,0,0,.393,1.466Zm-18.174,8.8-1.982,1.145a.785.785,0,0,0,.786,1.36l1.982-1.145a.785.785,0,1,0-.786-1.36Zm14.023-12.663a.786.786,0,0,0,1.073-.287l1.144-1.982a.785.785,0,1,0-1.36-.786l-1.144,1.982a.785.785,0,0,0,.287,1.073Zm6.525,13.808-1.982-1.146a.785.785,0,0,0-.785,1.36l1.982,1.146a.785.785,0,1,0,.785-1.36ZM212.174,137.8l-1.982-1.145a.785.785,0,1,0-.785,1.36l1.982,1.145a.785.785,0,1,0,.785-1.361Zm2.685-2.685a.785.785,0,0,0,1.361-.785l-1.145-1.982a.785.785,0,0,0-1.36.785Z" transform="translate(-207.333 -130.277)" fill="#fff" />
                    </svg>
                    Conversion formula</div>

                <div style={{ color: "white", marginBottom: 50, marginTop: 30 }}>
                    <label>Value:x (price)</label>
                    <div style={{ marginTop: 10, marginBottom: 10 }}>
                        <div>add: '+'</div>
                        <div>sub: '-'</div>
                        <div>div: '/'</div>
                        <div>mlt: '*'</div>
                        <div>mod: '%'</div>
                        <div>exp: '^'</div>
                    </div>
                    <div style={{ fontStyle: "italic" }}>example: 3^x*12/5*9+9.4*2</div>
                    <TextArea value={conversion} onChange={(e) => { setConversion(e.target.value || undefined) }} style={{ marginTop: 10 }} placeholder="Create conversion formula" rows={3} />
                </div>

            </>


            <div style={{ display: "flex", flexDirection: "row", gap: 15, justifyContent: "space-between" }}>
                <Button onClick={() => { goBack() }} style={{ backgroundColor: "#161616", color: "white", flex: 1, height: 50 }} type="default">BACK</Button>
                <Button onClick={() => { onClickOk() }} style={{ backgroundColor: "#161616", color: "white", flex: 1, height: 50 }} type="default">OK</Button>
            </div>
        </Modal>
    );
};

export default CreateConversion;